export function compressString(str, maxLength, options = {isFile: true}) {
    const { isFile } = options;
    if (str && str.length < maxLength) return str;
    let extension = undefined;
    if (isFile) extension = str.split('.').pop();
    let newString = str.split('.')[0];
    const replacedStrings = newString.substring(newString.length, newString.length - 4);
    // usedLength is the number of used strings e.g: '...' and extension
    const usedLength = extension && extension.length ? extension.length : "" + replacedStrings.length + "....".length;
    return newString.replace(replacedStrings, "").slice(0, maxLength > usedLength ? maxLength - usedLength : 1) + `...${replacedStrings}.${extension ? extension : ""}`;
}